import React from "react";
import "font-awesome/css/font-awesome.css";
import "./component_style.css";

export default () => (
  <div className="info-message">
    <i className="far fa-bell" />
    <span>Нет данных для отображения</span>
  </div>
);
